export const ROUTE_GAME = {
  WIDTH: 1280,
  HEIGHT: 720,
  TILE_SIZE: 48,
  PLAYER_SPEED: 172,
  PLAYER_RADIUS: 16,
  ENEMY_RADIUS: 15,
  OVERVIEW_DURATION_MS: 2_400,
  CAMERA_TWEEN_MS: 900,
  GAMEPLAY_ZOOM: 1.34,
  RESPAWN_PAUSE_MS: 420,
  MAX_DELTA_MS: 40,
  JOYSTICK_X: 118,
  JOYSTICK_Y: 594,
  JOYSTICK_RADIUS: 76,
  JOYSTICK_KNOB_RADIUS: 31,
  GATE_RADIUS: 26,
  PORTAL_RADIUS: 21,
  PORTAL_COOLDOWN_MS: 700,
  PORTAL_PROTECTION_MS: 550,
  QUESTION_MAX_LINES: 4,
} as const;

export const ROUTE_COLORS = {
  garden: 0x183f3a,
  gardenLight: 0x2f7864,
  lawn: 0x32765a,
  lawnShade: 0x245e49,
  hedge: 0x1c5a45,
  hedgeLight: 0x4b9b6a,
  path: 0xe6cf91,
  pathShade: 0xd7b775,
  pathEdge: 0x956c3f,
  water: 0x4bb5c6,
  portalA: 0x73d9b0,
  portalB: 0xa88bed,
  mosaicA: 0x19a7a0,
  mosaicB: 0xe76f51,
  mosaicC: 0xf4c95d,
  mosaicD: 0x78b159,
  wallDark: 0x244c48,
  playerOuter: 0xff6b35,
  playerInner: 0xffd166,
  waterOuter: 0x2d8bc9,
  waterInner: 0x9be7ff,
} as const;
